var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransformer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6335 35.9999L12.6786 35.9999L23.207 35.9999L11.1723 9.56738L0.756574 9.56738L0.756574 9.66719L12.6335 35.9999Z",
    fill: "#1b63cf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3003 26.4325L20.3454 26.4325L31.1043 26.4325L19.0696 1.43512e-07L8.4234 2.76696e-07L8.4234 0.0998062L20.3003 26.4325Z",
    fill: "url(#paint0_linear_3450_74601)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3450_74601",
    x1: 32.7347,
    y1: 23.7197,
    x2: 17.0908,
    y2: 6.65366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1b63cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00285631,
    stopColor: "#1b63cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6da2f2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransformer);
export default __webpack_public_path__ + "static/media/transformer.6a6a6884cf0964da289dac13675c1a51.svg";
export { ForwardRef as ReactComponent };